import { cn } from "@/lib/utils";

export const RISK_TONE = {
  stable: "text-emerald-400 border-emerald-800 bg-emerald-950/30",
  moderate: "text-amber-400 border-amber-800 bg-amber-950/30",
  elevated: "text-orange-400 border-orange-800 bg-orange-950/30",
  attention: "text-red-400 border-red-800 bg-red-950/40",
};
export const RISK_BAR = {
  stable: "bg-emerald-500", moderate: "bg-amber-500", elevated: "bg-orange-500", attention: "bg-red-500",
};

export function RiskBadge({ level, ht, className }) {
  return (
    <span className={cn("px-2.5 py-1 rounded-sm text-[11px] font-semibold uppercase tracking-wider border", RISK_TONE[level] || RISK_TONE.stable, className)}>
      {ht("risk_" + level)}
    </span>
  );
}

export function HCard({ children, className, ...props }) {
  return <div className={cn("bg-[#0A1620] border border-slate-800 rounded-md", className)} {...props}>{children}</div>;
}

export function Sparkline({ values, tone = "#2dd4bf" }) {
  if (!values || values.length < 2) return null;
  const max = Math.max(...values), min = Math.min(...values);
  const range = max - min || 1;
  const w = 120, h = 34;
  const pts = values.map((v, i) => `${(i / (values.length - 1)) * w},${h - ((v - min) / range) * (h - 6) - 3}`).join(" ");
  return (
    <svg width={w} height={h} className="overflow-visible">
      <polyline points={pts} fill="none" stroke={tone} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
